import React, { Component } from 'react';

class FeatureExtended extends Component {
  render() {
    const { data, reverse = false } = this.props;
    let publicUrl = process.env.PUBLIC_URL;
    let imgattr = 'image';

    return (
      <section className="p-80px-tb featured-1 position-relative bg-light">
        <div className="bordered-circle2"></div>
        <div className="container">
          <div className="row">
            <div className="col-md-12 m-50px-b">
              <h2 className="section-title font-weight-bold m-20px-b">{data.title}</h2>
              {data.lead && (
                <p className="lead text-primary font-weight-bold m-20px-b">{data.lead}</p>
              )}
              {data.content && (
                <p className="text-muted">{data.content}</p>
              )}
            </div>
          </div>

          {/* Steps/Features Grid */}
          {data.steps && (
            <>
              <div className="row m-50px-t">
                <div className="col-md-12 m-30px-b">
                  <h3 className="h3 font-weight-bold">{data.stepsTitle}</h3>
                </div>
              </div>
              <div className="row">
                {data.steps.map((step, i) => (
                  <div key={i} className="col-lg-6 m-30px-b">
                    <div className="d-flex align-items-start">
                      <div className="step-number">
                        <div className="rounded-circle bg-primary text-white p-20px text-center" style={{width: '60px', height: '60px', lineHeight: '20px'}}>
                          <h3 className="text-white m-0">{i + 1}</h3>
                        </div>
                      </div>
                      <div className="step-content m-20px-l">
                        <h4 className="font-weight-bold m-15px-b">{step.title}</h4>
                        <p className="text-muted m-0">{step.content}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* Key Points Section */}
          {data.keyPoints && (
            <>
              <div className="row m-50px-t">
                <div className="col-md-12 m-30px-b">
                  <h3 className="h3 font-weight-bold">{data.keyPointsTitle}</h3>
                </div>
              </div>
              <div className="row">
                {data.keyPoints.map((point, i) => (
                  <div key={i} className="col-lg-4 col-md-6 m-30px-b">
                    <div className="feature-box text-center p-30px">
                      <i className={`${point.icon} icofont-3x text-primary m-20px-b`}></i>
                      <h5 className="font-weight-bold m-15px-b">{point.title}</h5>
                      <p className="text-muted">{point.content}</p>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </section>
    );
  }
}

export default FeatureExtended;